const _excluded = ["className"],
  _excluded2 = ["separator", "container", "className"],
  _excluded3 = ["counter"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { useLightboxState, clsx, cssClass, createModule } from '../../index.js';
import { MODULE_CONTROLLER, PLUGIN_COUNTER } from '../../types.js';
const defaultCounterProps = {
  separator: "/",
  container: {}
};
const resolveCounterProps = counter => _objectSpread(_objectSpread({}, defaultCounterProps), counter);
function CounterComponent(_ref) {
  let counter = _ref.counter;
  const _useLightboxState = useLightboxState(),
    slides = _useLightboxState.slides,
    currentIndex = _useLightboxState.currentIndex;
  const _resolveCounterProps = resolveCounterProps(counter),
    separator = _resolveCounterProps.separator,
    _resolveCounterProps$ = _resolveCounterProps.container,
    className = _resolveCounterProps$.className,
    rest = _objectWithoutProperties(_resolveCounterProps$, _excluded),
    legacyClassName = _resolveCounterProps.className,
    legacyRest = _objectWithoutProperties(_resolveCounterProps, _excluded2);
  if (slides.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", _objectSpread(_objectSpread({
    className: clsx(cssClass("counter"), className || legacyClassName)
  }, legacyRest), rest), currentIndex + 1, " ", separator, " ", slides.length);
}
function Counter(_ref2) {
  let augment = _ref2.augment,
    addChild = _ref2.addChild;
  augment(_ref3 => {
    let counter = _ref3.counter,
      restProps = _objectWithoutProperties(_ref3, _excluded3);
    return _objectSpread({
      counter: resolveCounterProps(counter)
    }, restProps);
  });
  addChild(MODULE_CONTROLLER, createModule(PLUGIN_COUNTER, CounterComponent));
}
export { Counter as default };